import {
  mdiCurrencyUsd,
  mdiHomeOutline,

  // mdiMopedElectricOutline,
  mdiShieldAlertOutline,
  mdiTrophyVariantOutline,
} from '@mdi/js'

export default [
  {
    subheader: 'Ferramentas de integração',
  },
  {
    title: 'Dashboard',
    to: 'integrator-dashboard',
    icon: mdiHomeOutline,
    ActiveTabColor: '#9429FF',
    ActiveTabColor2: '#9429FF',
  },
  {
    title: 'Comissões',
    to: 'commissions-home',
    icon: mdiCurrencyUsd,
    ActiveTabColor: '#9429FF',
    ActiveTabColor2: '#9429FF',
  },

  // {
  //   title: 'Entregas',
  //   to: 'list-bonifications',
  //   icon: mdiMopedElectricOutline,
  //   ActiveTabColor: '#9429FF',
  //   ActiveTabColor2: '#9429FF',
  // },
  {
    title: 'Inconsistências',
    to: 'list-inconsistencies',
    icon: mdiShieldAlertOutline,
    ActiveTabColor: '#9429FF',
    ActiveTabColor2: '#9429FF',
  },
  {
    title: 'Premiações',
    icon: mdiTrophyVariantOutline,
    children: [
      {
        title: '2° e 5° parcela',
        to: 'list-commission-quote',
        ActiveTabColor: '#9429FF',
        ActiveTabColor2: '#9429FF',
      },
      {
        title: 'Crescimento',
        to: 'sigma-params-growth',
        ActiveTabColor: '#9429FF',
        ActiveTabColor2: '#9429FF',
      },
      {
        title: 'Emplacamento',
        to: 'integrator-registration',
        ActiveTabColor: '#9429FF',
        ActiveTabColor2: '#9429FF',
      },

      // {
      //   title: 'Top 3',
      //   to: 'top-three',
      //   ActiveTabColor: '#9429FF',
      //   ActiveTabColor2: '#9429FF',
      // },
    ],
  },

  {
    subheader: 'Ferramentas da Central',
  },

  // NOTE - Aba removida do integrador, mas permanece no projeto para uso futuro
  {
    title: 'Premiações',
    to: 'awards-home',
    icon: mdiTrophyVariantOutline,
    ActiveTabColor: '#9429FF',
    ActiveTabColor2: '#9429FF',
  },
]
